export { MarketingLogo } from "./MarketingLogo";
export type { MarketingLogoProps } from "./MarketingLogo.types";
